import React from 'react';
import PropTypes from 'prop-types';

const OMLabelTop = props => {
  const { isMobile, inMultiPin, title } = props;

  const renderIcon = () => (
    <div className="icon icon-top-promotion-active" title={title}>
      <i className="path1" />
      <i className="path2" />
      <i className="path3" />
    </div>
  );

  return (
    !(isMobile && inMultiPin) && renderIcon()
  );
};


OMLabelTop.propTypes = {
  label: PropTypes.string,
  title: PropTypes.string,
  isMobile: PropTypes.bool,
  inMultiPin: PropTypes.bool
};

export default OMLabelTop;
